module.exports = __webpack_public_path__ + "static/img/img2.1523ace.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img2.png
// module id = gEhE
// module chunks = 1